<se-fe-card>
  <se-fe-card-header
    seFeDataTitle="Feature: Parent / Guardian Info"
    seFeDataSubtitle="Adding Parent / Guardian Info for a Child"
  ></se-fe-card-header>
  <se-fe-card-content>
    <se-po-household-setup-feature-parent-guardian-info></se-po-household-setup-feature-parent-guardian-info>
  </se-fe-card-content>
</se-fe-card>
